<template>
     <div class="lightRailTraffic">
          <h2>{{$t('traffic_type[2]')}}</h2>
          <trafficRoute :traffic_route="n" v-for="(n,i) in this.busTraffic_route" :key="i"></trafficRoute>
     </div>
</template>

<script>
    import trafficRoute from './trafficRoute';
    export default {
        name: "lightRailTraffic",
        props:['busTraffic_route'],
        components: {
            trafficRoute
        }
    }
</script>

<style scoped  lang="less">
     @import '../../assets/less/common.less';
     @height: 30px;
     .lightRailTraffic {
          width: @width;
          h2 {
               line-height: 50px;
          }

     }
</style>
